import React, {
    ComponentType, FC, useEffect, useState,
} from 'react';
import { useSecureUser } from 'libs/additiv-react-oidc-client';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../ui-library';
import { INIT_LOCATION } from '../constants/sessionStorageKeys';

const withInitLocation = <P extends object>(
    WrappedComponent: ComponentType<P>,
): FC<P> => {
    const Component: FC<P> = (props) => {
        const secureUser = useSecureUser();
        const [isWithInitLocation, setWithInitLocation] = useState<boolean>(
            () => !!sessionStorage.getItem(INIT_LOCATION),
        );
        const navigate = useNavigate();

        useEffect(() => {
            const storedLocation = sessionStorage.getItem(INIT_LOCATION);

            if (secureUser && storedLocation) {
                sessionStorage.removeItem(INIT_LOCATION);
                setWithInitLocation(false);
                navigate(storedLocation);
            } else if (secureUser) {
                // Ensure loader stops if user is authed but no redirect is needed
                setWithInitLocation(false);
            }
        }, [secureUser, navigate]);

        if (isWithInitLocation) {
            return <Loader />;
        }

        return <WrappedComponent {...props} />;
    };

    Component.displayName = `WithInitLocation(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

    return Component;
};

export default withInitLocation;
